
import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';

const Accounting = () => {
  const [summary, setSummary] = useState({ paid: 0, pending: 0 });
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');



  ////////////////////// get token user and pass //////////////////
const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
 
const mydb = username.slice(0, 3);

      
//////////////////////



  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await fetch('/myinvoice/summary?mydb=' + mydb);
        const data = await res.json();
        setSummary(data);
      } catch (error) {
        console.error('Error fetching invoice summary:', error);
      }
    };

    const fetchInvoices = async () => {
      try {
        const res = await fetch('/myinvoice?mydb=' + mydb);
        const data = await res.json();
        setInvoices(data);
      } catch (error) {
        console.error('Error fetching invoices:', error);
      }
    };

    Promise.all([fetchSummary(), fetchInvoices()]).then(() => setLoading(false));
  }, []);

  // Filter invoices by search term and date range
  const filteredInvoices = invoices.filter(invoice => {
    const matchesSearch = invoice.client_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.orderid.toString().includes(searchTerm);

    const invoiceDate = new Date(invoice.date);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const matchesFromDate = from ? invoiceDate >= from : true;
    const matchesToDate = to ? invoiceDate <= to : true;

    return matchesSearch && matchesFromDate && matchesToDate;
  });

  // Calculate totals based on filtered invoices
  const totalPaid = filteredInvoices
    .filter(inv => inv.invoice_state === 'paid')
    .reduce((sum, inv) => sum + inv.amount, 0);

  const totalPending = filteredInvoices
    .filter(inv => inv.invoice_state === 'pending')
    .reduce((sum, inv) => sum + inv.amount, 0);

  if (loading) {
    return (
      <div style={{
        padding: '20px',
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5rem',
        color: '#34495e',
      }}>
        Loading...
      </div>
    );
  }

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <a href="/"
          style={{
            padding: '10px 20px',
            backgroundColor: '#3498db',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#2980b9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#3498db';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          <span style={{ fontSize: '18px' }}>←</span>
          Home
        </a>
        <input
          type="text"
          placeholder="Search by Client Name or Order ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '1px solid #dce4ec',
            borderRadius: '8px',
            fontSize: '14px',
            width: '250px',
            flexShrink: 0,
          }}
        />
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <label htmlFor="fromDate" style={{ fontSize: '14px', color: '#2c3e50' }}>From:</label>
          <input
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              padding: '6px 10px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              cursor: 'pointer',
              maxWidth: '150px'
            }}
          />
          <label htmlFor="toDate" style={{ fontSize: '14px', color: '#2c3e50' }}>To:</label>
          <input
            type="date"
            id="toDate"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              padding: '6px 10px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              cursor: 'pointer',
              maxWidth: '150px'
            }}
          />
          {(fromDate || toDate) && (
            <button
              onClick={() => {
                setFromDate('');
                setToDate('');
              }}
              style={{
                padding: '6px 12px',
                backgroundColor: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear Dates
            </button>
          )}
        </div>
      </div>

      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '30px',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          padding: '20px',
          flex: '0 0 150px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#155724',
          fontWeight: '600',
          fontSize: '1.2rem',
          minHeight: '150px',
        }}>
          <div>Total Paid</div>
          <div style={{ fontSize: '1.5rem', marginTop: '8px' }}>${totalPaid.toFixed(2)}</div>
        </div>
        <div style={{
          backgroundColor: '#fff3cd',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          padding: '20px',
          flex: '0 0 150px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#856404',
          fontWeight: '600',
          fontSize: '1.2rem',
          minHeight: '150px',
        }}>
          <div>Total Pending</div>
          <div style={{ fontSize: '1.5rem', marginTop: '8px' }}>${totalPending.toFixed(2)}</div>
        </div>
      </div>

      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflowX: 'auto',
        marginBottom: '100px', // add margin bottom to avoid footer overlap
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          minWidth: '600px', // reduce minWidth for better responsiveness
        }}>
          <thead>
            <tr style={{
              backgroundColor: '#f8f9fa',
              borderBottom: '2px solid #dee2e6',
            }}>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>ID</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Order ID</th>
              <th style={{ padding: '12px', textAlign: 'right', color: '#2c3e50' }}>Amount</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Invoice State</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Client Name</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Client ID</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Tel1</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Tel2</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Address</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Note</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Payment Method</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.map((invoice) => {
              const isPaid = invoice.invoice_state === 'paid';
              const isPending = invoice.invoice_state === 'pending';
              return (
                <tr key={invoice.id} style={{
                  backgroundColor: isPaid ? '#d4edda' : isPending ? '#fff3cd' : 'transparent',
                  borderBottom: '1px solid #dee2e6',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e9f7ef'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = isPaid ? '#d4edda' : isPending ? '#fff3cd' : 'transparent'}
                >
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.id}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.orderid}</td>
                  <td style={{ padding: '12px', textAlign: 'right', color: '#27ae60', fontWeight: '600' }}>${invoice.amount.toFixed(2)}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.invoice_state}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.client_name}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.client_id}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.tel1}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.tel2}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.address}</td>
                  <td style={{ padding: '12px', color: '#7f8c8d' }}>{invoice.note}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{invoice.paymentmethod}</td>
                  <td style={{ padding: '12px', color: '#2c3e50' }}>{new Date(invoice.date).toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Docked Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
        backgroundColor: 'white',
        borderRadius: '12px 12px 0 0',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        marginTop: '20px',
        fontSize: '14px',
        color: '#2c3e50',
        zIndex: 1000,
      }}>
        <button
          disabled
          style={{
            padding: '8px 16px',
            backgroundColor: '#e9ecef',
            color: '#6c757d',
            border: 'none',
            borderRadius: '4px',
            cursor: 'not-allowed',
            fontSize: '14px'
          }}
        >
          Previous
        </button>
        <span style={{
          display: 'flex',
          alignItems: 'center',
          color: '#2c3e50',
          fontSize: '14px'
        }}>
          Page 1 of 1 (0 Invoices)
        </span>
        <button
          disabled
          style={{
            padding: '8px 16px',
            backgroundColor: '#e9ecef',
            color: '#6c757d',
            border: 'none',
            borderRadius: '4px',
            cursor: 'not-allowed',
            fontSize: '14px'
          }}
        >
          Next
        </button>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Accounting;
